angular.module('app.registration.registrationService', [])
.factory('app.registration.registrationService', [
    '$http',
    function ($http) {
        return {
            register: function (reg_info) {
                return $http.post(window.location.api('users'), reg_info);
            }
        }
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/registration/registrationService.js